// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { animateScroll as scroll } from 'react-scroll/modules';
import CancelModal from '../../components/CancelModal/CancelModal';

import commonStyle from '../../../components/OrderCommon.scss';
import style from './LookingForTraveler.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import radar from '../../../../../assets/img/order/beta_radar.png';

import type { Order } from '../../../../../entities';
import type { HTTPError } from '../../../../../error';
import type { Node } from 'react';

type Props = {
  +buildProducts: () => Node;
  +buildSummary: (contentBottom?: Node) => Node;
  +isCanceling?: boolean;
  +cancelOrder: (orderId: string) => void;
  +cancelError?: HTTPError;
  +cancelSuccessful?: boolean;
  +order?: Order;
};

type State = {
  cancelModalOpen: boolean;
};

export default class LookingForTraveler extends Component<Props, State> {
  state = {
    cancelModalOpen: false,
  };

  componentDidUpdate(prevProps: Props) {
    const { cancelError, cancelSuccessful } = this.props;
    if (!prevProps.cancelError && !!cancelError || !prevProps.cancelSuccessful && !!cancelSuccessful) {
      this.setState({
        cancelModalOpen: false,
      });
      this.scrollAnimateTop();
    }
  }

  handleCloseModal = () => {
    this.setState({ cancelModalOpen: false });
  };


  scrollAnimateTop = () =>
    scroll.scrollTo(0, {
      duration: 400,
    });

  render() {
    const { buildProducts, buildSummary, isCanceling, cancelOrder, order } = this.props;
    const { cancelModalOpen } = this.state;

    const cancelButton = (
      <Fragment>
        <br/>
        <FormattedMessage id="order.purchase.lookingForTravelers.cancel.button">{
          txt => <button onClick={() => this.setState({ cancelModalOpen: true })}
                         className={style.cancel}>{txt}</button>
        }</FormattedMessage>
      </Fragment>
    );

    return (
      <Fragment>
        <main className={commonStyle.mainWrap}>
          <section className={classNames(commonStyle.wrap, commonStyle.leftWrap)}>
            <article className={style.lookingForTravelersWrap}>
              <FormattedMessage id="order.purchase.lookingForTravelers.title">{
                txt => <h2 className={style.title}>{txt}</h2>
              }</FormattedMessage>
              <section className={classNames(boxStyle.box, style.box)}>
                <img src={radar}
                     className={style.radar}/>
                <FormattedMessage id="order.purchase.lookingForTravelers.text">{
                  txt => <p>{txt}</p>
                }</FormattedMessage>
              </section>
            </article>
            {buildProducts()}
          </section>
          <section className={classNames(commonStyle.wrap, commonStyle.rightWrap)}>
            {buildSummary(cancelButton)}
            {/*<FormattedMessage id="order.purchase.lookingForTravelers.cancel.button">{
              txt => <button onClick={() => this.setState({ cancelModalOpen: true })}
                             className={classNames(buttonStyle.btn, buttonStyle.red, style.cancel)}>{txt}
              </button>
            }</FormattedMessage>*/}
            
          </section>
        </main>
        {order && <CancelModal modalVisible={cancelModalOpen}
                               orderId={order.id}
                               handleClose={this.handleCloseModal}
                               isCanceling={isCanceling}
                               cancelOrder={cancelOrder}/>}
      </Fragment>
    );
  }
}

LookingForTraveler.propTypes = {
  buildProducts: PropTypes.func.isRequired,
  buildSummary: PropTypes.func.isRequired,
  isCanceling: PropTypes.bool,
  cancelError: PropTypes.object,
  cancelOrder: PropTypes.func.isRequired,
  cancelSuccessful: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/looking-for-traveler/components/LookingForTraveler.jsx